import React from 'react';

const UploadSpeed = () => {
  return (
    <svg style={{transform: 'rotate(180deg)'}} width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="10" fill="#141827"/>
    <path d="M6.25 9.39941L9.73483 12.8842C9.88128 13.0307 10.1187 13.0307 10.2652 12.8842L13.75 9.39941" stroke="white" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M9.9931 12.6465L9.98047 5.14648" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.125 15.4004H11.875" stroke="white" strokeWidth="1.25" strokeLinecap="round"/>
    </svg>
  )
}

export default UploadSpeed;